module.exports = __webpack_public_path__ + "img/6_149.fd65eb36.png";